// Shared tag normalization rules, matching what's already enforced when
// tagging records from the Delivery table / record details & edit pages
// (see TaggingStrip.tsx): tags are stored lowercase, trimmed, capped at
// 100 characters, and may not contain a forward slash (tag names are sent
// as a URL path segment).
export const MAX_TAG_LENGTH = 100

export function normalizeTag(value: string): string {
  return value.toLowerCase().replace(/\//g, '').trim().slice(0, MAX_TAG_LENGTH)
}

export function normalizeTags(values: string[]): string[] {
  const sanitized = values.map(normalizeTag).filter(tag => tag.length > 0)

  return [...new Set(sanitized)]
}

// Normalizes a tag then percent-encodes it (e.g. ' ' -> '%20', '/' -> '%2F').
// Use this whenever a tag name is sent as part of a request URL path.
export function encodeTagForQuery(tag: string): string {
  return encodeURIComponent(normalizeTag(tag))
}
